import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css'
// import Test from './Test';
import Nav from './Nav/Nav';
import Home from './Home/Home';
import Goals from './Goals/Goals';
import Donate from './Donate/Donate';
import Footer from './Footer/Footer';
import Quote from './Quote/Quote';
import Contact from './Contact/Contact';
import Details from './Details/Details';


function App() {
  return (
    <>
    <BrowserRouter>
    <Nav/>
      <Routes>
      <Route path="/" element={
            <>
              <Home/>
              <Quote/>
              <Goals/>
              <Donate/>
              <Details/>
              <Contact/>
            </>
          }
        />
      </Routes>
      <Footer/>
    </BrowserRouter>
    </>
  );
}

export default App;
